const qs = (selector) => document.querySelector(selector);
const qsa = (selector) => [...document.querySelectorAll(selector)];

const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
const isAndroid = /android/i.test(navigator.userAgent);
const isMobile = isIOS || isAndroid;

(() => {
  const initCleanup = () => {
    const wrap = document.querySelector('.shopify-payment-button-wrap');
    if (wrap) wrap.remove();
  };

  const setDarkFavicon = () => {
    const isDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
    if (isDarkMode) {
      const darkURL = document.querySelector('#favicon-dark-url').innerHTML;
      const favicon = document.querySelector('#favicon');
      favicon.href = darkURL;
    }
  };

  // const frameManager = () => {
  //   const googleURL = 'https://pay.google.com/gp/p/ui/payframe';
  //   setInterval(function() {

  //     const iframes = qsa('iframe');
  //     const googleFrame = iframes.find(f => f.src && f.src.includes(googleURL));
  //     if (googleFrame) {
  //       googleFrame.remove();
  //       clearInterval(this);
  //     }

  //   }, 200);
  // };

  // const searchaniseKiller = () => {
  //   const isScript = e => e.tagName === 'SCRIPT';
  //   const isStyle = e => e.tagName === 'LINK' && ((e.rel && e.rel === 'stylesheet') || (e.type && e.type=== 'text/css'));
  //   let timeElapsed = 0;
  //   let interval = 50;

  //   setInterval(function() {
  //     const contentLoader = document.querySelectorAll('script, link');
  //     let searchaniseFound = 0;
  //     for (const l of contentLoader) {
  //       const isSearchJS = isScript(l) && l.src && l.src.includes('searchanise');
  //       const isSearchCSS = isStyle(l) && l.href && l.href.includes('searchanise');

  //       if (isSearchCSS || isSearchJS) {
  //         l.remove();
  //         searchaniseFound++;
  //       }
  //     }

  //     timeElapsed += interval;

  //     if (timeElapsed > 500 && searchaniseFound === 0) clearInterval(this);
  //   }, interval);
  // };

  const addCommasToNumbers = () => {
    const numbers = [...document.querySelectorAll('.tl-number')];
    for (const number of numbers) {
      const withCommas = parseInt(number.innerHTML).toLocaleString();
      number.innerHTML = withCommas;
    }
  };

  const removeCenterTags = () => {
    const centers = [...document.querySelectorAll('center')];
    if (!centers) return;
    for (const center of centers) {
      const content = center.innerHTML;
      center.insertAdjacentHTML('afterend', /*html*/`<div>${content}</div>`);
      center.remove();
    }
  };

  const rewardsProgramFix = () => {
    setInterval(function() {
      const frame = document.querySelector('.smile-launcher-frame');
      if (!frame) return; 
      const btn = frame.contentDocument.querySelector('.launcher-button');
      if (!btn) return;
      btn.style.opacity = 0;
      frame.style.display = 'none';
      clearInterval(this);
    });
  };
  const sitemapCleaner = () => {
    if (!location.href.includes('/apps/sitemap')) return;
    const toExclude = [
      '/pages/welcome-to-the-true-leaf-app',
      '/pages/asset-table',
      '/pages/wf-confirm',
      '/pages/wholesale-order-form'
    ];

    const isHiddenName = n => n[0].toLowerCase() === n[0] && !n.includes(' ') && (n.includes('-') || n.includes('_'));

    const links = [...document.querySelectorAll('.sitemapper-list a')];
    const toRemove = links
    .filter(l => toExclude.includes(l.href) || isHiddenName(l.innerText))
    .forEach(l => l.remove());
  };

  initCleanup();
  setDarkFavicon();
  //frameManager();
  rewardsProgramFix();
  removeCenterTags();
  //searchaniseKiller();
  addCommasToNumbers();
  sitemapCleaner();
})();


/*

const TabWatcher = {
  _isVisible: true,
  _events: {
    hidden: 'tab-hidden',
    visible: 'tab-visible'
  },

  init() {
    document.addEventListener('visibilitychange', event => {
      const name = this._events[document.hidden ? 'hidden' : 'visible'];

      const detail = {
        timestamp: new Date()
      };

      const customEvent = new CustomEvent(name, {detail});
      document.dispatchEvent(customEvent);
      this._isVisible = !document.hidden;
    });
  },

  onHidden(func) {
    document.addEventListener(this._events.hidden, func);
  },

  onVisible(func) {
    document.addEventListener(this._events.visible, func);
  },

  get isVisible() {
    return this._isVisible;
  }
};
TabWatcher.init();

const exampleUses = () => {
  TabWatcher.onHidden(function(event) {
    console.log(`I was hidden at ${event.detail.timestamp}!`);
  });

  TabWatcher.onVisible(function(event) {
    console.log(`I was made visible at ${event.detail.timestamp}!`);
  });

  if (TabWatcher.isVisible) {
    console.log('I am visible!');
  }

}

*/

